// URLs de la plateforme publique (injectées au build via VITE_PUBLIC_APP_URL)
export const PUBLIC_APP_URL = import.meta.env.VITE_PUBLIC_APP_URL || 'https://e-kaa.app';
